import { hot } from 'react-hot-loader/root';
import React, {useState} from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'
import favicon from './images/logo.png';
import './App.css';
import Home from './components/pages/Home';
import HeaderTop from "./components/header-top";
import Patient from "./components/pages/Patients";
import Admission from "./components/pages/Admission";
import Discharge from "./components/pages/Discharge";
import Footer from "./components/footer";
import AdmissionPdf from "./components/pages/Admission/admissionPdf";
import OpnotePdf from "./components/pages/Opnote/opnotePdf"
import DischargePdf from "./components/pages/Discharge/dischargePdf";
import PatientVisit from "./components/pages/Visit";
import Login from "./components/pages/Login";
import Vte from "./components/pages/Vte/index";
import VtePdf from "./components/pages/Vte/vtepdf";
import Opnote from "./components/pages/Opnote";
import Basket from "./components/pages/Basket";
import ExportAdmission from "./components/pages/Export/admission";
import ExportOpnote from "./components/pages/Export/opnote";
import {Helmet} from 'react-helmet'
import {reactLocalStorage} from 'reactjs-localstorage';

function App() {
    const [path, setPath] = useState({path: window.location.pathname});


    return (

        <>
            <Helmet>

                <title>Department of Surgery Faculty of Medicine, Khon Kaen University {}</title>
                <link rel="icon" type="image/png" href={favicon} sizes="16x16"/>
            </Helmet>

            {!reactLocalStorage.get('token') || path.path == '/admission/pdf' || path.path == '/discharge/pdf' || path.path == '/opnote/pdf' ? '' :
                <HeaderTop/>}

            <div style={{flex: 1}}>
                <Switch>
                    <Route path="/home" component={Home}/>
                    <Route path="/patients" component={!reactLocalStorage.get('token') ? Login : Patient}/>
                    <Route path="/visit" component={!reactLocalStorage.get('token') ? Login : PatientVisit}/>
                    <Route path="/admission/pdf" component={!reactLocalStorage.get('token') ? Login : AdmissionPdf}/>
                    <Route path="/admission" component={!reactLocalStorage.get('token') ? Login : Admission}/>
                    <Route path="/discharge/pdf" component={!reactLocalStorage.get('token') ? Login : DischargePdf}/>
                    <Route path="/discharge" component={!reactLocalStorage.get('token') ? Login : Discharge}/>
                    <Route path="/opnote/pdf" component={!reactLocalStorage.get('token') ? Login : OpnotePdf}/>
                    <Route path="/opnote" component={!reactLocalStorage.get('token') ? Login : Opnote}/>
                    <Route path="/basket" component={!reactLocalStorage.get('token') ? Login : Basket}/>
                    <Route path="/export-admission" component={ExportAdmission}/>
                    <Route path="/export-opnote" component={ExportOpnote}/>
                    <Route path="/vte/pdf" component={VtePdf}/>
                    <Route path="/vte" component={Vte}/>
                    {!localStorage.getItem('token') ? <Route path="/login" component={Login}/> : ''}
                    {!localStorage.getItem('token') ?
                        <Redirect from={"/"} exac to={"/login"}/>
                        :
                        <Redirect from={"/"} exac to={"/home"}/>}
                </Switch>

            </div>
            {!reactLocalStorage.get('token') || path.path == '/admission/pdf' || path.path == '/discharge/pdf' || path.path == '/opnote/pdf' ? '' :
                <Footer/>}
        </>
    );
}

export default hot(App);
